import { createRemoteModule } from './remote-modules';
const currentMajorVersion = 11;
export const experimentallyImportRemoteModule = createRemoteModule({
    name: 'universal-layout',
    url: `https://cdn.zapier.com/universal-layout-remote-poc/versions/v${currentMajorVersion}/universal-layout.umd.js`,
});
export { withSSR } from './remote-modules';
//# sourceMappingURL=local.js.map
// @zapier/universal-layout@11.0.60 (de4647366)
